import React from 'react';
import { Wave } from './Wave';
export function Hero() {
  return <section className="w-full px-6 md:px-12 py-24 md:py-32 bg-navy" data-id="element-54">
      <div className="max-w-6xl mx-auto" data-id="element-55">
        <div className="max-w-4xl" data-id="element-56">
          <h1 className="font-display text-4xl md:text-6xl font-medium leading-tight mb-4" data-id="element-57">
            Premier Lead Generation Company Partnering With The Leading Law
            Firms On A Pay For Results Basis
          </h1>
          <Wave data-id="element-58" />
          <p className="text-lg md:text-xl text-gray-300 mt-8 mb-12 max-w-2xl" data-id="element-59">
            Unlike marketing agencies or lead aggregators, we've built
            specialized systems that source high-intent prospects at scale,
            pre-qualify them for case viability, and deliver them exclusively to
            attorneys - with no retainers, no agency fees, and no competition.
          </p>
          <div className="flex justify-start" data-id="element-60">
            <a href="https://calendly.com/customers-on-command/customers-on-command-1-1-interview" target="_blank" rel="noopener noreferrer" className="bg-primary hover:bg-primary-hover text-black font-medium px-8 py-4 rounded-md transition-all" data-id="element-61">
              Schedule a Call
            </a>
          </div>
        </div>
      </div>
    </section>;
}